// src/analytics/useGtmPageview.ts
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useGtmPageview() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const page_path = pathname + (search || "");
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);
}


export function gtmPush(event: string, params: Record<string, any> = {}) {
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({ event, ...params });
}